module.exports = __webpack_public_path__ + "static/sport/form-bg.f7421ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/form-pc/form-bg.png
// module id = 5yO/
// module chunks = 0